import moment from 'moment';

import { elk, url } from '@tencent/ppd-base-libs';
import { url as baseUtilsUrl } from '@tencent/wphk-base-utils';

// 使用本地时间
const localTime: string = url.getUrlParam('localTime');

export const reportSpCouponTimeException = ({ useCouponTime, msg }: { useCouponTime: string, msg: string }) => {
  // 服务器时间
  // 客户端时间
  // 使用券时间
  // 停止倒计时时间
  const stopCountDownTime = moment(String(useCouponTime) || '').add('10', 'minute');
  const data = {
    serverTime: getFormattedDateAndTime(getServerTime()),
    clientTime: getFormattedDateAndTime(new Date()),
    useCouponTime: getFormattedDateAndTime(useCouponTime),
    stopCountDownTime: getFormattedDateAndTime(stopCountDownTime),
    diffTime: (window as any).__$$_serverTimeDiff,
    serverTimeOnPageLoad: (window as any).__$$_serverTimeMills,
    msg,
  };
  elk({
    msg: JSON.stringify(data),
    key: 'spCouponTimeException',
  });
};

export const TEN_MIN = 600000;
export const getCountDownDiffTime = (useCouponTime: string) => {
  let currentDate = getServerTime();// 服务端时间
  const stopCountDownTime = moment(String(useCouponTime) || '').add('10', 'minute');
  let diffTime = 0;
  if (moment(currentDate).isBefore(stopCountDownTime)) {
    diffTime = stopCountDownTime.diff(currentDate);
    if (diffTime > TEN_MIN) {
      reportSpCouponTimeException({ useCouponTime, msg: 'server diff time error' }); // 上报
      currentDate = moment(); // 取客户端时间
      diffTime = stopCountDownTime.diff(currentDate);
      if (diffTime > TEN_MIN) {
        reportSpCouponTimeException({ useCouponTime, msg: 'client diff time error' }); // 上报
        return TEN_MIN; // 直接返回兜底10分钟
      }
    }
  }
  return diffTime;
};

export const getServerTime = () => moment(new Date()).subtract(
  // eslint-disable-next-line no-underscore-dangle
  (window as any).__$$_serverTimeDiff || 0, // 用0做兜底
  'milliseconds',
);
export const getFormattedDate = (date: any, format = 'YYYY-MM-DD') => moment(date).format(format);

export const getFormattedDateAndTime = (date: any, format = 'YYYY.M.D HH:mm:ss') => moment(date).format(format);

/**
 * 获取系统时间
 */
export function getServerDate(): Date {
  return new Date(getServerTime().valueOf());
}

/**
 * 是否在开始结束时间内
 * @param start 开始时间
 * @param end 结束时间
 */
export const isValidDate = (start: Date, end: Date) => {
  // mock系统时间
  const mockServerTime = baseUtilsUrl.getUrlParam('serverTime');
  let now = getServerDate();
  if (mockServerTime) {
    now = new Date(mockServerTime);
  } else if (localTime === '1') {
    now = new Date();
  }
  return now >= start && now <= end;
};

/**
 * 计算两个时间之间的剩余天数
 */
export function getGapDays(start: Date, end: Date) {
  const startMill = start.getTime();
  const endMill = end.getTime();
  // 剩余时间 -- 毫秒
  const gapMill = endMill - startMill;
  const days = (gapMill / (60 * 60 * 24 * 1000));
  return days;
}
